/** @format */

import buttonStyle from "./Button.module.scss";
const ButtonMethod = ({
    buttonText,
    color = "#fff",
    isGoogle = false,
    isFacebook = false,

    Icon = () => {},
    fontSize = "18px",
    height = 50,
    width = "100%",
    isLoading = false,
    onClick = () => {},
    ...props
}) => {
    let backgroundButton = "";
    let backgroundButtonSide = "";

    if (isFacebook) {
        backgroundButton = "#007bfe";
        backgroundButtonSide = "rgba(0,123,254,.2)";
    } else if (isGoogle) {
        backgroundButton = "#d21919";
        backgroundButtonSide = "rgba(210,25,25,.2)";
    } else {
		backgroundButton = "#000000";
		backgroundButtonSide= "#939393";
	}

    return (
        <div
            className={buttonStyle.wrapper}
            style={{
                width: "100%",
                height: height,
                borderRadius: height / 2,
                background: backgroundButtonSide,
            }}>
            <div
                className={`${buttonStyle.button} `}
                style={{
                    fontSize: fontSize,
                    width: "100%",
                    height: height,
                    color: color,
                    borderRadius: height / 2,
                    color: color,
                    background: backgroundButton,
                    // border: white && "1px solid #E0E0E0",
                }}
                onClick={onClick}
                {...props}>
                <Icon />
                {buttonText}
            </div>
        </div>
    );
};
export default ButtonMethod;
